<ng-container *ngIf="isForApplicantClient()">
  <ats-applicant-home></ats-applicant-home>
</ng-container>
<ng-container *ngIf="isForUserClient()">
  <ats-user-home></ats-user-home>
</ng-container>
